import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../header/header';
import TagManager from 'react-gtm-module';
import Footer from '../footer/footer';
import { withTranslation, WithTranslation } from 'react-i18next';
import { listenToAccessibilityKeyboardInputs } from '../../accessibleNavigation';
import config from '../../config';

interface IPagePros extends WithTranslation {
    pageTitle: string;
    pageContent?: any;
}

const Page = (props: IPagePros) => {
    const { pageTitle, pageContent } = props;

    if (config.ENV && config.ENV !== 'development') {
        TagManager.initialize({
            gtmId: config.GTM_ID ?? '',
        });

        // Facebook Pixel initialization using runtime config
        if (config.FACEBOOK_PIXEL_ID) {
            // eslint-disable-next-line no-undef
            if (typeof (window as any).fbq === 'function') {
                // eslint-disable-next-line no-undef
                (window as any).fbq('init', config.FACEBOOK_PIXEL_ID);
                // eslint-disable-next-line no-undef
                (window as any).fbq('track', 'PageView');
            }
        }
    }

    setTimeout(function () {
        document.querySelectorAll('.popover-container').forEach(function (popoverContainer) {
            popoverContainer.removeAttribute('aria-expanded');
            popoverContainer.setAttribute('role', 'button');
        });

        // Set keyboard event listener for all markup marked as button
        document.querySelectorAll('[role="button"], a').forEach(function (button) {
            listenToAccessibilityKeyboardInputs(button);
        });
    }, 500);

    return (
        <HelmetProvider>
            <Helmet>
                <base href="%PUBLIC_URL%/" />
                <title>{pageTitle}</title>
            </Helmet>
            <Header />
            {pageContent}
            <Footer />
        </HelmetProvider>
    );
};

export default withTranslation()(Page);
